import React, { useEffect, useState } from 'react'
import swapBodyBg from '../../assets/images/swapBodyBg.png'
import swapContentbox1 from '../../assets/images/swapContentbox1.png'
import swapContentbox3 from '../../assets/images/swapContentbox3.png'
import brainChair from '../../assets/images/brain-chair.gif'
import swapBg from '../../assets/images/swapBg.jpg'
import mobileSwapBodyBg from '../../assets/images/mobile-swapBodyBg.png'
import Lottie from 'react-lottie'
import arrowsJson from '../../assets/animation/arrows.json'
import bubbleJson from '../../assets/animation/bubble.json'
import sideicon from '../../assets/images/sideicon.png'
import bsc from '../../assets/images/token-list/token7.png'
import tron from '../../assets/images/token-list/token3.png'
import eth from '../../assets/images/token-list/token1.png'
import tok from '../../assets/images/logo.svg'
import SwapTrading from '../../components/TradingView/Swap'
import buyIcon from '../../assets/images/buy-icon.png'
import optionsIcon from '../../assets/images/options-icon.png'
import { useExpertModeManager, useUserDeadline, useUserSlippageTolerance } from '../../state/user/hooks'

import { NavLink, useLocation, useHistory } from 'react-router-dom'

import { isMobile } from 'react-device-detect'

import styled, { keyframes } from 'styled-components'
const slideIn = keyframes`
  from {
    transform: translate(-50%, -20px);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
`
const HomeWrap = styled.div`

  background: #fff;
    width: 100%;
    height: 100%;
  /* min-height: calc(100vh); */
  /* background: url('${swapBg}')top center/auto; */
  .changbg{
    display: flex;
  align-items: center;
  justify-content: center;
    max-width: 1300px;
  padding-top: 30px;
  margin: auto;
  padding-left:10px ;
  padding-right: 10px;
  }
  @keyframes move {
    0% {
      box-shadow: 0 0 #00ff0d;
    }
    100% {
      box-shadow: 0 0 44px 6px #00ff0d;
    }
  }
  .content{
    /* margin-top: -100px;
    overflow */
    max-width: 1300px;
    width: 100%;
    overflow: hidden;
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
    margin: auto;
    /* flex-wrap: wrap; */
    /* padding: 0 10px; */
    gap: 10px;
    padding-left:10px ;
    padding-right: 10px;
    .left{
      width: 100%;
    }
    .box{
    width: 500px;
    background: #F4FDFF;
    padding: 32px;
    margin:0 auto;
    border: 1px solid #c9f7ff;
height: fit-content;
      /* width: 100%; */
    }
    .swapBox {
      width: 450px;
      /* min-height: 645px; */
      /* padding: 71px 83px 73px 41px;
      background: url('${swapBodyBg}')top center/100% 100%; */
      padding: 43px;
      background: #335db2;
      border-radius: 20px;
      border: 4px solid #000;
      position: relative;
      margin-right: 50px;
      flex-shrink: 0;
      &::after{
        position: absolute;
        content: '';
        width: 52px;
        height: 137px;
        right: -51px;
        top: 35%;
        background: url('${sideicon}')top center/100% 100%;  ;
      }
        .decoratebox{
          position: relative;
          left: -30px;
          top: -30px;
          display: flex;
          align-items: center;
          gap: 10px;
          .decorate1{
            width: 15px;
            height: 15px;
            background: #5EB049;
            border-radius: 50%;
          }
          .decorate2{
            width: 46px;
            height: 13px;
            background: #F44F4F;
            border-radius: 7px 7px 7px 7px;
          }
          .decorate3{
            width: 15px;
            height: 15px;
            background: #E29593;
            border-radius: 50%;
          }
        }
        .sideRight{

        }
      .box {
        height: 100%;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        padding: 18px 18px 33px 18px;
        font-family: 'Inter'
      }
    }
    .flex{
      display: flex;
      align-items: center;
    }
    .center {
      margin-left: 90px;
      .center-title {
        white-space: nowrap;
        font-weight: 900;
        font-size: 48px;
        color: #000000;
        font-style: italic;
      }
      .big-title{
        white-space: nowrap;
        font-size: 60px;
        color: #5EB049;
        line-height: 70px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        -webkit-text-stroke: 4px #000000;
      }
      .contentBox1 {
        margin-top: 20px;
        width: 513px;
        height: 210px;
        padding: 27px 99px 27px 25px;
        background: url('${swapContentbox1}')top center/100% 100%;
        .item {
          margin-bottom: 16px;
          span {
            font-weight: 900;
            font-size: 16px;
            color: #ffffff;
            line-height: 20px;
          }
          .item-title {
            display: inline-block;
            font-size: 18px;
            color: #5eb049;
            line-height: 16px;
            text-transform: none;
            -webkit-text-stroke: 1px #000000;
            margin-right: 1em;
          }
        }
      }
      .contentBox2 {
        margin-top: 26px;
        max-width: 425px;
        padding: 29px 28px;
        background: #a6d59d;
        border-radius: 30px 30px 30px 30px;
        border: 3px solid #83a97b;
        font-weight: 900;
        font-size: 16px;
        color: #000000;
        line-height: 20px;
        margin-left: 40px;
      }
      .contentBox3 {
        margin-top: 26px;
        max-width: 459px;
        height: 170px;
        padding: 29px 20px;
        background: url('${swapContentbox3}')top center/100% 100%;
        font-weight: 900;
        font-size: 16px;
        color: #000000;
        line-height: 20px;
        margin-left: 70px;
        .content-title {
          font-weight: 900;
          font-size: 28px;
          color: #5eb049;
          line-height: 28px;
          -webkit-text-stroke: 1.5px #000000;
          margin-bottom: 25px;
        }
      }
    }
    .rightBox{
      position: relative;
      left: 20px;
      display: flex;
      align-items: center;
      .gif{
        margin-top: 120px;
        height: 529px;
      }
    }
    .header-box{
      display: flex;
      align-items: center;
      padding: 12px;
      background: #F4FDFF;
      .avt{
        display: flex;
        align-items: center;
        .img{
          width: 32px;
          height: 32px;
          /* border: 1px solid #fff; */
          border: 1px solid #3973B4;
          border-radius: 50%;
          overflow: hidden;
          padding: 3px;
          box-shadow: 0 5px 10px rgba(0,0,0,.3);
          img{
            width: 100%;
            height: 100%;
          }
       
          &:last-child {
            position: relative;
            z-index: 1;
          margin-left:-8px ;
          background: #fff;
          }
        }
      }
      .text-title{
        margin-left: 8px;
        font-size: 20px;
        font-weight: 600;
      }
    }
  }
  .powered{
    /* padding: 80px auto; */
    max-width: 1300px;
    display: flex;
    font-size: 16px ;
    font-weight: 600;
    padding-left:10px ;
    padding-right: 10px;
    background: #fff;
    margin: 40px auto;
    img{
      width: 20px;
      height: 20px;
      border-radius: 50%;
      margin-right: 5px;
      margin-left: 10px;
    }
  @media (max-width: 768px) {
    img{
      margin-left: 0;
    }
  }
  }
  @media (max-width: 768px) {
    padding-top: 0;
    display: block;
    /* height: fit-content; */
    /* background-attachment: fixed; */
    background-size: cover;
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 0 10px;
    .content{
      margin-top: 0px;
      display: block;
      /* padding: 30px 0px; */
      align-items: center;
      .box{
        width: 100%;
        padding: 16px;
      }
      .swapBox{
        min-height: fit-content;
        width: 100%;
        padding: 30px 25px 30px;
        /* background: url('${mobileSwapBodyBg}')top center/100% 100%; */
        &::after{
          display: none;
      }
      .decoratebox{
        left: -10px;
        top: -20px;
      }
        .box{
        }
      }
      .center{
        margin-left: 0;
        .center-title{
          display: none;
        }
        .big-title{
          display: none;
        }
        .contentBox1{
          background: none;
          width: 100%;
          background: #335DB2;
          height:fit-content;
          border-radius: 16px 16px 16px 16px;
          border: 2px solid #000000;
          padding: 30px 18px 20px;
          .item{
            span{
              font-size: 13px;
              line-height: 14px;
              font-weight: 600;

            }
          }

        }
        .contentBox2{
          width: 100%;
          font-weight: 600;
          line-height: 16px;
          font-size: 13px;
          padding: 24px;
          border-radius: 16px 16px 16px 16px;
          margin-left: 0;
          margin-top: 0 !important;
        }
        .contentBox3{
          width: 100%;
          margin-left: 0;
          padding:24px 14px;
          line-height: 13px;
          height: fit-content;
          font-weight: 600;
          font-size: 13px;
          .content-title{
            font-weight: 900;
            font-size: 20px;
            margin-bottom: 12px;
          }

        }
      }
     
      .mobileSet{
        display: flex;
        flex-direction: column-reverse;
      }
      .moboileArrorw{
        width: 100%;
        height: fit-content;
        margin-top: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: rotate(90deg);
      }
      .rightBox{
        margin-top: 25px;
        .gif{
          margin-top: 0;
        display: block;
        margin-left: auto;
        width: 228px;
        height: auto;
      }
        }
     
    }
    .changbg{
      padding: 0;
      padding-top: 20px;
    }
  }

`
const BoxWrap = styled.div`
  width: ${({ path }) => (path === '/swap' ? '' : '100%')};
  .options-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
    .buy {
      display: flex;
      align-items: center;
      font-size: 16px;
      cursor: pointer;
      gap: 4px;
      img {
        height: 15px;
      }
    }
    .option {
      display: flex;
      align-items: center;
      cursor: pointer;
      gap: 4px;
      background: #f1fbff;
      border-radius: 9999px;
      padding: 8px 15px;
      img {
        /* height: 18px; */
        width: 18px;
      }
    }
  }
`

const BubbleJsonLottieAnimation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: bubbleJson
  }

  return (
    <Lottie
      options={defaultOptions}
      width={isMobile ? 68 : 119}
      className="test"
      style={{
        position: 'absolute',
        top: isMobile ? '-40%' : '23%',
        left: isMobile ? '30%' : '-60px',
        transform: isMobile ? 'rotate(80deg)' : ''
      }}
    />
  )
}

const Message = styled.div`
  position: fixed;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 0;
  padding: 12px 24px;
  background-color: #f3f4f6; /* Neutral gray background */
  color: #1f2937; /* Dark gray text */
  border: 1px solid #d1d5db; /* Light gray border */
  border-radius: 6px;
  font-size: 15px;
  transition: opacity 0.3s ease-in-out;
  width: fit-content;
  z-index: 1000;
  opacity: ${({ show }) => (show ? 1 : 0)};
  pointer-events: none;
  animation: ${slideIn} 0.3s ease-out forwards; /* Apply slide-in animation */
  @media (max-width: 768px) {
    top: 90px;
  }
`

export default function HomeWrapBody({ children }) {
  const [allowedSlippage] = useUserSlippageTolerance()

  const { pathname } = useLocation()
  function test() {
    const button = document.getElementById('open-settings-dialog-button')

    if (button) button.click()
  }
  const [showMessage, setShowMessage] = useState(false)
  useEffect(() => {
    if (showMessage) {
      const timer = setTimeout(() => {
        setShowMessage(false)
      }, 3000) // 3秒后自动隐藏

      return () => clearTimeout(timer) // 清除定时器，防止内存泄漏
    }
  }, [showMessage])

  return (
    <>
      <HomeWrap>
        {showMessage && <Message show={showMessage}>Coming Soon !</Message>}
        <div className="changbg">
          <div className="content">
            {pathname === '/swap' && !isMobile && (
              <div className="left">
                <BoxWrap>
                  <div className="options-box" style={{ opacity: 0, pointerEvents: 'none' }}>
                    <div
                      className="buy"
                      onClick={() => {
                        setShowMessage(true)
                      }}
                    >
                      <img src={buyIcon} />
                      Buy
                    </div>
                    <div className="option" onClick={test}>
                      <img src={optionsIcon} />
                      {allowedSlippage / 100}%
                    </div>
                  </div>

                  <SwapTrading />
                </BoxWrap>
              </div>
            )}

            <BoxWrap path={pathname}>
              {pathname === '/swap' && (
                <div className="options-box">
                  <div
                    className="buy"
                    onClick={() => {
                      setShowMessage(true)
                    }}
                  >
                    <img src={buyIcon} />
                    Buy
                  </div>
                  <div className="option" onClick={test}>
                    <img src={optionsIcon} />
                    {allowedSlippage / 100}%
                  </div>
                </div>
              )}

              <div className="box">{children && children}</div>
            </BoxWrap>
          </div>
        </div>
        {pathname === '/swap' && (
          <div className="powered">
            <img src={tok} /> Powered by Dovra Chain
          </div>
        )}
      </HomeWrap>
    </>
  )
}
